import { ErrorTypeCommon } from '@/interfaces/ErrorCodeSignature/ErrorCode';
import { getErrorCodes } from '@/utils/errorHelper';

import styles from './CustomErrorStyle.module.scss';

interface CustomErrorProps {
  errorCode: ErrorTypeCommon;
}

export default function CustomError({ errorCode }: CustomErrorProps) {
  const errorMessage = getErrorCodes(errorCode);

  return (
    <div className={styles.containerSignatureError}>
      <div className={styles.errorTextSignature}>{errorMessage}</div>
    </div>
  );
}
